<template lang="pug">
v-avatar(
  v-bind="attrs"
)
  v-img(
    :src="src"
  )
</template>

<script>
export default {
  name: 'UserAvatar',
  props: {
    img: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
  },
  computed: {
    attrs() {
      return {
        size: 48,
        ...this.$attrs,
      };
    },
    src() {
      if (!this.img) {
        return require('@/assets/no-avatar.png');
      }

      return this.img;
    },
  },
};
</script>
